module.exports = " <header _v-32f32003=\"\"> <div class=navbar-toggle id=show-offcanvas @click=toggleSidebar _v-32f32003=\"\"> <i class=iconfont _v-32f32003=\"\"></i> </div> <div class=send-btn title=发帖 v-link=\"{path: '/newtopic'}\" _v-32f32003=\"\"> <i class=iconfont _v-32f32003=\"\"></i> </div> <h2 _v-32f32003=\"\">{{title}}</h2> </header> ";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/template-rewriter.js?id=_v-32f32003!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/vHeader.vue
 ** module id = 89
 ** module chunks = 2
 **/